// Used by Microsoft AppInsights
// For more information: https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript-react-plugin
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();
export default reactPlugin;
